import { clsx } from "clsx";
import { type ChangeEvent, Component, type ReactElement } from "react";

import { Label } from "widgets";

import { TooltipController } from "../overlays/components/OverlayControllers.js";

export interface ICheckboxProps {
  id: string;
  checked?: boolean;
  partiallyChecked?: boolean;
  defaultChecked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  label?: string | ReactElement;
  disabled?: boolean;
  tooltipText?: string; // not an HTML property!
}

export interface ICheckboxState {
  defaultChecked: boolean;
}

const hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

function emptyFn() {
  /* empty */
}

export class Checkbox extends Component<ICheckboxProps, ICheckboxState> {
  constructor(props: ICheckboxProps) {
    super(props);
    this.state = {
      defaultChecked: this.props.defaultChecked,
    };

    this.isChecked = this.isChecked.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  render(): ReactElement {
    const props = { ...this.props, onChange: this.handleChange, label: "" };
    const { tooltipText, partiallyChecked, ...htmlProps } = props;
    const htmlPropsWithLabel = { ...htmlProps };

    const inputCheckboxClassNames = clsx({ partiallyChecked: partiallyChecked });
    // Attention! {...htmlProps} is required here otherwise the checkbox
    // will not work in the Column Selection Dialog.
    return (
      <TooltipController content={tooltipText}>
        {(tooltipTriggerProps) => (
          <span onPointerEnter={tooltipTriggerProps.onPointerEnter} onPointerLeave={tooltipTriggerProps.onPointerLeave}>
            <input
              type="checkbox"
              {...htmlPropsWithLabel}
              checked={this.isChecked()}
              disabled={this.props.disabled || false}
              className={inputCheckboxClassNames}
            />
            <Label htmlFor={this.props.id} itemRef={tooltipTriggerProps.ref}>
              {this.props.label || " "}
            </Label>
          </span>
        )}
      </TooltipController>
    );
  }

  private isChecked(): boolean {
    return this.props.partiallyChecked || this.getValue() || false;
  }

  private getValue(): boolean {
    const props = this.props;
    return hasOwn(props, "checked") ? props.checked : this.state.defaultChecked;
  }

  private handleChange(event) {
    const value = this.props.partiallyChecked ? true : event.target.checked;
    const props = this.props;

    // if (props.supportIndeterminate){
    //   var oldValue = this.getValue()
    //
    //   if (typeof props.nextValue == 'function'){
    //     value = props.nextValue(oldValue, this.props)
    //   }
    // }

    (props.onChange || emptyFn)(event);

    if (!hasOwn(props, "checked")) {
      this.setState({
        defaultChecked: value,
      });
    }

    event.stopPropagation();
  }
}

export default Checkbox;
